// SPDX-License-Identifier: AGPL-3.0-or-later

import {msg} from '@lingui/core/macro';

export const SERVER_TAG_TAB_LABEL_DESCRIPTOR = msg({
	message: 'Server tag',
	context: 'community-settings-tab',
	comment: 'Community settings tab for configuring the community server tag shown next to member names.',
});

export const SERVER_TAG_DESCRIPTION_DESCRIPTOR = msg({
	message:
		'Members can show this tag next to their names. People outside your community can click the tag to view your community profile or ask to join.',
	context: 'server-tag',
	comment: 'Intro description on the community server tag settings page.',
});

export const SERVER_TAG_UNLOCK_WITH_BOOST_DESCRIPTOR = msg({
	message: 'Unlock with Boost',
	context: 'server-tag',
	comment: 'CTA button that opens the boost tab when the server tag perk is locked.',
});

export const SERVER_TAG_CHOOSE_NAME_DESCRIPTOR = msg({
	message: 'Choose a name',
	context: 'server-tag',
	comment: 'Section heading for the server tag text field (max 4 characters).',
});

export const SERVER_TAG_NAME_HINT_DESCRIPTOR = msg({
	message: 'Maximum 4 characters. Letters and numbers only.',
	context: 'server-tag',
	comment: 'Helper text under the server tag name input.',
});

export const SERVER_TAG_UPDATE_NOTICE_DESCRIPTOR = msg({
	message:
		'Updating the tag name or badge requires members to re-select it on their profiles. This helps prevent abuse.',
	context: 'server-tag',
	comment: 'Info callout explaining that members must re-apply the tag after community changes.',
});

export const SERVER_TAG_CHOOSE_BADGE_DESCRIPTOR = msg({
	message: 'Choose a badge',
	context: 'server-tag',
	comment: 'Section heading for picking the server tag badge icon.',
});

export const SERVER_TAG_SHOW_ALL_BADGES_DESCRIPTOR = msg({
	message: 'Show all badges',
	context: 'server-tag',
	comment: 'Button that expands the full server tag badge grid.',
});

export const SERVER_TAG_SHOW_FEWER_BADGES_DESCRIPTOR = msg({
	message: 'Show fewer badges',
	context: 'server-tag',
	comment: 'Button that collapses the server tag badge grid back to the featured set.',
});

export const SERVER_TAG_CHOOSE_COLOR_DESCRIPTOR = msg({
	message: 'Choose a color',
	context: 'server-tag',
	comment: 'Section heading for picking the server tag badge color.',
});

export const SERVER_TAG_CUSTOM_COLOR_DESCRIPTOR = msg({
	message: 'Custom color',
	context: 'server-tag',
	comment: 'Accessible label for the custom color picker control in the server tag color grid.',
});

export const SERVER_TAG_PREVIEW_TITLE_DESCRIPTOR = msg({
	message: 'Preview',
	context: 'server-tag',
	comment: 'Title of the live chat-style preview card for the server tag.',
});

export const SERVER_TAG_PREVIEW_MESSAGE_DESCRIPTOR = msg({
	message: 'Check out my tag!',
	context: 'server-tag',
	comment: 'Sample chat message shown in the server tag live preview.',
});

export const SERVER_TAG_LOCKED_HINT_DESCRIPTOR = msg({
	message: 'Server tags unlock at Boost Level {level} ({boosts} boosts).',
	context: 'server-tag',
	comment:
		'Helper under the unlock CTA. {level} is the boost tier number; {boosts} is the required boost count.',
});

export const SERVER_TAG_PLACEHOLDER_DESCRIPTOR = msg({
	message: 'TAG',
	context: 'server-tag',
	comment: 'Placeholder text inside the empty server tag name field. Keep short (≤4 chars if possible).',
});

export const SERVER_TAG_SAVED_DESCRIPTOR = msg({
	message: 'Server tag saved',
	context: 'server-tag',
	comment: 'Success toast after saving community server tag settings.',
});

export const SERVER_TAG_SAVE_FAILED_DESCRIPTOR = msg({
	message: 'Failed to save server tag. Try again.',
	context: 'server-tag',
	comment: 'Error toast when saving community server tag settings fails.',
});

export const SERVER_TAG_NONE_OPTION_DESCRIPTOR = msg({
	message: 'No server tag',
	context: 'server-tag',
	comment: 'Dropdown option that clears the user’s equipped server tag.',
});

export const SERVER_TAG_PROFILE_SECTION_DESCRIPTOR = msg({
	message: 'Server tag',
	context: 'server-tag',
	comment: 'Section heading on the profile customization page for choosing a server tag.',
});

export const SERVER_TAG_PROFILE_HINT_DESCRIPTOR = msg({
	message: 'Choose a community whose tag appears next to your name.',
	context: 'server-tag',
	comment: 'Helper text under the profile server tag dropdown.',
});
